export default __webpack_public_path__ + "static/media/abstract.fd3e35cf.jpg";